// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xDjbTGXJADFBIVrjTsZQ {
  transform: rotate(0);
}

.tKbclbKsbepJ34NqEqSj {
  transform: rotate(180deg);
}

.W4Y_pacpt57PSvSxbXOA {
  transform: rotate(270deg);
}

.Qk7q3fPwN0zX4cvgD1x2 {
  transform: rotate(90deg);
}
`, "",{"version":3,"sources":["webpack://./src/components/icons/Chevron/Chevron.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".down {\n  transform: rotate(0);\n}\n\n.up {\n  transform: rotate(180deg);\n}\n\n.right {\n  transform: rotate(270deg);\n}\n\n.left {\n  transform: rotate(90deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"down": `xDjbTGXJADFBIVrjTsZQ`,
	"up": `tKbclbKsbepJ34NqEqSj`,
	"right": `W4Y_pacpt57PSvSxbXOA`,
	"left": `Qk7q3fPwN0zX4cvgD1x2`
};
export default ___CSS_LOADER_EXPORT___;
